import type { EnderecoBloqueado } from "../../../services/enderecosBloqueados"

export enum EnderecosBloqueadosActionsTypes {
    CARREGAR = "CARREGAR",
}

export type EnderecosBloqueadosActions = {
    type: EnderecosBloqueadosActionsTypes.CARREGAR
    payload: EnderecoBloqueado[]
}
